// extracted by mini-css-extract-plugin
export default {"modal":"MoveOrg_modal__bkfXI","buttonGroup":"MoveOrg_buttonGroup__B5q1H"};